import { z } from "zod";

import { ErrorSource } from "@/app/constants/constants";

export const GeneralErrorSchema = z.object({
  message: z.string(),
  source: z.nativeEnum(ErrorSource).optional(),
  errors: z.array(z.string()).optional(),
});
